import Vue from "vue";
import './plugins/vuetify'
import './plugins/vuetify'
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Scroll To:
var VueScrollTo = require('vue-scrollto');
// Vue.use(VueScrollTo);
// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "body",
    duration: 3500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

// AOS - AnimateOnScroll:
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import './assets/_custom.scss';
import Vuetify from 'vuetify';

Vue.use(Vuetify, {
    iconfont: 'mdi'
});
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-155993223-1" }
}, router);

Vue.config.productionTip = false;

new Vue({
    created () {
        AOS.init()
    },
  router,
  store,
  vuetify : new Vuetify(),
  render: h => h(App)
}).$mount("#app");
